<template>
  <div class="pageNotFound" id="status404">
    <BackgroundImage url="page-not-found.jpg" lowResUrl="page-not-found-lowres.jpg" color="#a2dff5"></BackgroundImage>
    <Navigation></Navigation>
    <div class="contents m-t-4 container-fluid">
        <div class="col-md-6 centerCol">
          <Card class="pageNotFoundCard">
          <div slot="title">
            <div class="text-xs-center">{{t('The page you were looking for was not found')}}</div>
          </div>
          <div slot="content">
            <div class="text-xs-center m-t-2">
              <p></p>
            </div>
            <div class="actions m-t-2 text-xs-center">
              <router-link class="btn btn-primary" :to="`/${language}`">{{t('go to Home')}}</router-link>
            </div>
          </div>
          </Card>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Navigation from './components/Navigation/Navigation';
import BackgroundImage from './components/BackgroundImage';
import Card from './components/Card';

export default {
  name: 'PageNotFound',
  components: {
    Navigation,
    BackgroundImage,
    Card,
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.pageNotFound {
  min-height: 100vh;
}

.centerCol {
  float:none;
  margin-top: 30vh;
  margin-left: auto;
  margin-right: auto;
}

</style>



// WEBPACK FOOTER //
// NotFound.vue?c1609506